import { render, staticRenderFns } from "./NButtonLoading.vue?vue&type=template&id=c6ee3238&scoped=true&"
import script from "./NButtonLoading.vue?vue&type=script&lang=js&"
export * from "./NButtonLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ee3238",
  null
  
)

export default component.exports